/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Graph, createMeasurement, TimeSeriesForecast } from 'integ-graphs'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { getUnitIds, getUnitMap, getEntityTargetInfo } from 'analytics/selectors'
import { Select, Spin } from 'antd'
import { retrieveUnitList, retrieveUnitInfoMap } from 'analytics/actions'

import moment from 'moment'
import * as api from 'api/entity-api'

import { Content, FullHeightSizer } from 'core/screen-util'
// const elementSpecs = [{ metricType: 'EAF', minValue: 35.33, maxValue: 100 }]
// const entities = [{ entityType: 'UNIT', entityId: 'abc-unit' }]

const getDateBounds = moment => ({
  minDate: moment
    .clone()
    .startOf('month')
    .add(-6, 'months')
    .toDate(),
  maxDate: moment
    .clone()
    .startOf('month')
    .add(6, 'months')
    .toDate(),
})

// const now = new Date().getTime()

// const mockData = baseDate =>
//   mockMothlyForecastTimeSeries({
//     elementSpecs,
//     entities,
//     ...getDateBounds(baseDate),
//   }).filter(
//     d =>
//       moment(d.recordDate)
//         .toDate()
//         .getTime() <= now
//   )

const measurement = createMeasurement({
  height: 500,
  margin: { top: 20, right: 20, bottom: 100, left: 50 },
})

const H2 = styled.h2`
  margin-left: 50px;
`

class TimeSeriesContainer extends React.Component {
  constructor(props) {
    super(props)
    const { retrieveUnitList, retrieveUnitInfoMap } = this.props
    retrieveUnitList(moment())
    retrieveUnitInfoMap()
    this.state = {
      data: [],
      selectedUnit: undefined,
      baseDate: moment(),
    }
    this.unitSelected = this.unitSelected.bind(this)
  }

  unitSelected = value => {
    const { /* loadData, */ targetInfo } = this.props
    // TODO: due to missing data we need to be in 2017 we should use now
    const date = moment()

    const req = {
      unitid: value,
      utility: value.substr(0, 3),
      unit: value.substr(3),
      year: date.format('YYYY'),
      month: date.format('MM'),
    }

    // this.setState({ data: mockData(date), baseDate: date, selectedUnit: value })

    this.setState(
      {
        selectedUnit: value,
        loading: true,
      },
      () => {
        api
          .forecastMetrics(targetInfo)(req)
          .then(res => res.json())
          .then(data =>
            this.setState({
              data: data.filter(d => d.metricType === this.props.metricName),
              baseDate: date,
              loading: false,
            })
          )
      }
    )
  }

  render() {
    const { metricName, unitIds, unitMap } = this.props
    const { data, loading, baseDate } = this.state
    const units = unitIds.map(id => ({ key: id, value: id, text: unitMap[id] }))

    const dateBounds = getDateBounds(baseDate)
    return (
      <FullHeightSizer heightOffset={170}>
        {({ height }) => (
          <Spin spinning={loading}>
            <Content
              css={{
                height: height - 20,
                paddingTop: '10px',
                minHeight: height,
                display: 'grid',
                gridTemplateColumns: '20% 80%',
                gridTemplateRows: '10% 80%',
              }}
            >
              <H2>{metricName} Forecast</H2>
              <div>
                <Select
                  placeholder="Unit"
                  search
                  selection
                  options={units}
                  onChange={this.unitSelected}
                >
                  {units.map(e => (
                    <Select.Option key={e.key} value={e.value}>
                      {e.text}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <div style={{ gridColumnEnd: '2 span' }}>
                <Graph measurement={measurement}>
                  <TimeSeriesForecast
                    measurement={measurement}
                    data={data}
                    {...dateBounds}
                    minValue={0}
                    maxValue={100}
                  />
                  {/* <Legend measurement={measurement} /> */}
                </Graph>
              </div>
            </Content>
          </Spin>
        )}
      </FullHeightSizer>
    )
  }
}

const mapStateToProps = state => ({
  unitIds: getUnitIds(state),
  unitMap: getUnitMap(state),
  targetInfo: getEntityTargetInfo(state),
})

export default connect(mapStateToProps, {
  retrieveUnitList,
  retrieveUnitInfoMap,
})(TimeSeriesContainer)
